import React from "react";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";

const FooterAlt = () => {
  return (
    <React.Fragment>
      <div className="footer-alt py-3">
        <Container>
          <Row className="align-items-center">
            <Col lg={3}>
              <div className="text-center text-white">
                  Sede Legale in Via Umberto I, N°62, 04100 Latina
              </div>
            </Col>
            <Col lg={2}>
              <div className="text-center text-white">
                  P.IVA: 02807480591
              </div>
            </Col>
            <Col lg={2}>
              <div className="text-center text-white">
                  {new Date().getFullYear()} © tenergia.it
              </div>
            </Col>
            <Col lg={2}>
              <div className="text-center text-white">
                  Powered by <Link to='https://reversoadv.it'>reversoadv</Link>
              </div>
            </Col>
            <Col lg={3}>
              <div className="text-center text-white">
                <Link to='/privacy-policy'>Informativa privacy</Link>
              </div>
            </Col>
            
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}
export default FooterAlt;
